import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase credentials');
}

// Must match @/lib/supabaseSsrClient (cookie session). Plain createClient() uses
// localStorage, so after server-side signIn the browser had no JWT and RLS
// blocked updates (PGRST116 / 0 rows on PATCH with .single()).
export const supabase = createBrowserClient(supabaseUrl, supabaseKey);
